import moment from "moment";

import TwoDayDeliveryBadge from "@/components/two-day-delivery-badge/twoDayDeliveryBadge";
import style from "../checkoutReviewVendorOrderSection.module.scss";

export default function VendorHeader({
  vendorName,
  deliveryDate,
  isConfirmationPage,
}: {
  vendorName: string;
  deliveryDate?: Date;
  isConfirmationPage: boolean;
}) {
  const buildEstimatedDeliveryDate = () => {
    const twoDayDeliveryDate = moment(deliveryDate);
    return twoDayDeliveryDate.format("MMM DD, YYYY");
  };

  return (
    <div className={style["vendor-order-header-container"]}>
      <div className={style["vendor-order-header-flex"]}>
        <div className={style["vendor-order-header-vendor-name-container"]}>
          <span className={style["vendor-name"]}>{vendorName}</span>
        </div>
        <div className={style["vendor-order-header-shipping-description-container"]}>
          <p className={style["vendor-shipping-description"]}>
            <TwoDayDeliveryBadge size="1x" visible={true} isConfirmationPage={isConfirmationPage} />
            <span className={style["arriving-text"]}>&nbsp;Arriving&nbsp;</span>
            <span>{buildEstimatedDeliveryDate()}</span>
          </p>
        </div>
      </div>
    </div>
  );
}
